import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { HelpArticleLink } from '../../components/help-article-link';

/**
 * Renders a clickable link to terms and conditions with an external link icon
 * @param {object} props
 * @param {string} props.termKey - Unique identifier for the term, used as article ID
 * @param {string} [props.termUrl] - Optional URL to override the default article URL
 * @param {object} props.termText - Internationalized message object for the link text
 * @param {string} [props.version] - Version number of the terms
 * @param {string} [props.iconClass] - CSS class for styling the external link icon
 * @param {string} [props.linkClass] - CSS class for styling the link container
 * @returns {React.JSX.Element} Link component with text and external link icon
 */
export const TermLink = ({ termKey, termUrl = undefined, termText, version, iconClass = undefined, linkClass = undefined }) => {
  return (
    <HelpArticleLink key={termKey} articleId={termKey} className={linkClass} url={termUrl} version={version}>
      <Text element='span' textType={TextType.Paragraph} value={termText} />
      <FontAwesomeIcon className={iconClass} icon={faExternalLinkAlt} />
    </HelpArticleLink>
  );
};
